import getCasTableCellValue from '../getCasTableCellValue';
import ICasRenderCellProps from '../ICasRenderCellProps';

interface ICasRenderSplitStringArrayCellProps extends ICasRenderCellProps {
  separator?: string;
}

export function CasRenderSplitStringArray({
  row,
  column,
  separator = ',  ',
}: ICasRenderSplitStringArrayCellProps) {
  return getCasTableCellValue({ row, column })?.split(separator)?.map((item: string) => <div>{item}</div>);
}
